module.exports = __webpack_public_path__ + "img/桂林理工.2ff254ee.png";